import { gsap } from 'gsap';
import { PixiPlugin } from "gsap/PixiPlugin";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from "gsap/ScrollSmoother";

// gsap.registerPlugin(PixiPlugin, MotionPathPlugin, ScrollTrigger, ScrollSmoother);
gsap.registerPlugin(PixiPlugin, MotionPathPlugin, ScrollTrigger);


// create the smooth scroller FIRST!
// wondow.smoother = ScrollSmoother.create({
//     content: "#body",
//     smooth: 3,
//     normalizeScroll: true,
//     ignoreMobileResize: true,
//     effects: true,
//     // preventDefault: true,
//     // ease: 'power4.out',
//     // smoothTouch: 0.1,
// });

export default gsap;